import { datadogRum } from '@datadog/browser-rum';

if (import.meta.env.VITE_ACCOUNT_HOME_DATADOG_ENABLED === 'true') {
  datadogRum.init({
    applicationId: '2908428c-998d-4128-a18d-d294caf53781',
    clientToken: 'pub69059c2bebf3cd6a2dea77db6ecf95d1',
    defaultPrivacyLevel: 'mask-user-input',
    env: import.meta.env.VITE_ENV,
    service: 'cnu-dashboard',
    sessionReplaySampleRate: 0,
    sessionSampleRate: 100,
    site: 'datadoghq.com',
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version: `${import.meta.env.VITE_GIT_COMMIT}-${import.meta.env.VITE_GIT_COMMIT_OVERLAYS}`,
  });
}
